var React = require('react');

function AssetBankAccount (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#333647","d":"M9.48 0l9.504 5.016v2.016H0V5.016L9.48 0zm4.488 9h3v7.032h-3V9zM0 21v-3h18.984v3H0zM7.968 9h3v7.032h-3V9zm-6 0h3v7.032h-3V9z","key":0}),React.createElement("path",{"d":"M-2-1h24v24H-2z","key":1})]));
}

AssetBankAccount.defaultProps = {"viewBox":"0 0 19 21"};

module.exports = AssetBankAccount;

AssetBankAccount.default = AssetBankAccount;
